module.exports = __webpack_public_path__ + "static/media/holofoil.d687e2c2.png";